import Dropdown from 'react-bootstrap/Dropdown';
import '../../../styles/MarkerPopup.css'
import { execScript } from '../../../http/complexesApi.js';
import { notify } from '../../helpers.js';

const DropdownScripts = (props) => {
    if (props.complex.scripts.length === 0) return null
    return (
        <Dropdown>
         <Dropdown.Toggle variant="outline-warning" id="dropdown-basic"  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '3px'}}>
            {/* <span className='fa fa-terminal'></span> */}
            <svg className='popup_svg' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
              <path  d="M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                fill='black'
            /></svg>
          </Dropdown.Toggle>
    
          <Dropdown.Menu>
            {
              props.complex.scripts.filter(s => s.description === 'map').map((scr) => {
                const t = () => {
                  console.log(scr)
                  notify(props.notify, 'info', {head: props.complex.name, body: 'Выполнение команды, дождитесь завршения'})
                  execScript(props.complex, scr, (type, message) => {
                    console.log(type, message)
                    notify(props.notify)
                    notify(props.notify, type, message)
                  })
                  
                }
                return <Dropdown.Item key={scr.id} onClick={t}>{scr.name}</Dropdown.Item>
              })
            }
          </Dropdown.Menu>
        </Dropdown>
    );
}

export default DropdownScripts;